import React from 'react';
import { MdCall, MdCallMade } from 'react-icons/md';
import styles from '../../styles/icons/callIcon.scss';
import CombinedIconTopRight from './CombinedIconTopRight';
const OutboundCall = (props) => (React.createElement(CombinedIconTopRight, Object.assign({ MainIcon: MdCall, SmallIcon: MdCallMade, colorSmall: 'red', className: styles.nudge_2 }, props)));
export default OutboundCall;
